import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { ITask } from '@nimbus-assistant/models/task.model';
import { TaskTransferService } from '@nimbus-assistant/services/task-transfer.service';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { IconWeight } from '@nimbus-library/features/shared/directives/icon-weight.enum';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { PortalTranslationKeys } from '@nimbus-library/features/localization/models/enums/portal-translation-keys.enum';
import { SharedUIModule } from '@nimbus-library/features/shared/shared.ui.module';
import { FooterInfoComponent } from '../shared/info/footer-info.component';

@UntilDestroy()
@Component({
  standalone: true,
  selector: 'app-footer-on-hold',
  templateUrl: './footer-on-hold.component.html',
  styleUrls: ['./footer-on-hold.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, SharedUIModule, FooterInfoComponent],
})
export class FooterOnHoldComponent {
  @Input({ required: true }) public task: ITask;

  public readonly ICONS = ICONS;
  public readonly IconWeight = IconWeight;
  public readonly TranslationKeys = TranslationKeys;
  public readonly statusText = PortalTranslationKeys.AssistantSessionFooterConversationStatePutOnHold;
  public readonly actionsDisabled$ = new BehaviorSubject<boolean>(false);

  public constructor(private readonly taskTransferService: TaskTransferService) {}

  public onRetrieve(): void {
    this.actionsDisabled$.next(true);
    this.taskTransferService
      .resume()
      .pipe(
        finalize(() => {
          this.actionsDisabled$.next(false);
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }

  public onTerminateCall(): void {
    this.actionsDisabled$.next(true);
    this.taskTransferService
      .terminateCall()
      .pipe(
        finalize(() => {
          this.actionsDisabled$.next(false);
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
